export function showDtnaAlertDialog(title, message, style = 0, timeMS = 3000) {
    const _dialogContainerClass = 'alert_dialog_container';
    const _boxBackdropClass = 'alert_dialog_box_backdrop';
    const _dialogShowDialogClass = 'show_dialog';
    const _dialogCloseIconClass = 'close_icon';

    const isAlertStyle = style >= 0 && style <= 9;
    const isToastStyle = style >= 10 && style <= 19;

    let _titleIconElement = '';

    if (isAlertStyle) {
        let _titleContainer = '';
        if (!!title) {
            _titleContainer = document.createElement("div");
            _titleContainer.classList.add("title_container");
            _titleContainer.textContent = title;
        }

        const _newITag = document.createElement("i");
        _newITag.classList.add("far");
        _newITag.classList.add("fa-times-circle");

        const _newDivTag = document.createElement("div");
        _newDivTag.classList.add(_dialogCloseIconClass);
        _newDivTag.appendChild(_newITag);

        _titleIconElement = document.createElement("div");
        _titleIconElement.classList.add("title_close_icon_container");
        if (_titleContainer) {
            _titleIconElement.appendChild(_titleContainer);
        }
        _titleIconElement.appendChild(_newDivTag);
    }

    const _newDivMessageContainer = document.createElement("div");
    _newDivMessageContainer.classList.add("message_container");
    _newDivMessageContainer.textContent = message ?? 'No message';

    const _dialogBox = document.createElement("div");
    _dialogBox.classList.add("alert_dialog_box");
    if (_titleIconElement) {
        _dialogBox.appendChild(_titleIconElement);
    }
    _dialogBox.appendChild(_newDivMessageContainer);

    const classStyle = isToastStyle ? 'toast_style' : 'alert_style';

    let _boxBackdropString = '';
    if (isAlertStyle) {
        _boxBackdropString = document.createElement("div");
        _boxBackdropString.classList.add(_boxBackdropClass);
    }

    const _dialogContainer = document.createElement("div");
    _dialogContainer.classList.add(_dialogContainerClass);
    _dialogContainer.classList.add(classStyle);
    if (_boxBackdropString) {
        _dialogContainer.appendChild(_boxBackdropString);
    }
    _dialogContainer.appendChild(_dialogBox);

    document.body.appendChild(_dialogContainer);

    setTimeout(function () {
        _dialogContainer.classList.add(_dialogShowDialogClass);
    }, 50);

    const _hideAndRemoveDialogBox = function (_dialog) {
        if (_dialog) {
            _dialog.classList.remove(_dialogShowDialogClass);

            setTimeout(function () {
                _dialog.remove();
            }, 100);
        }
    }

    if (isToastStyle) {
        setTimeout(() => {
            _hideAndRemoveDialogBox(_dialogContainer);
        }, timeMS ?? 3000);
    } else {
        const _closeIcon = _dialogBox.querySelector(`.${_dialogCloseIconClass}`);
        _closeIcon.removeEventListener('click', function (e) { });
        _closeIcon.addEventListener('click', function (e) {
            _hideAndRemoveDialogBox(_dialogContainer);
        });
    }

    const _boxBackdrop = _dialogContainer.querySelector(`.${_boxBackdropClass}`);
    if (_boxBackdrop) {
        _boxBackdrop.removeEventListener('click', function (e) { });
        _boxBackdrop.addEventListener('click', function (e) {
            _hideAndRemoveDialogBox(_dialogContainer);
        });
    }
}
